module.exports = __webpack_public_path__ + "static/assets/4408464bcbd290c1cca26a815823895c.png";